/*jshint esversion: 6, globalstrict: true, eqnull:true, browser: true, node: true */
"use strict";
const isRequired = () => {
  throw new Error("param is required");
};

var convertObjectProperties = function (objProps) {
  //converts {FieldName:xzy, FieldValue: abx} to {xyz:"abc"}
  if (!objProps) return {};
  var outObjProps = {};
  objProps.forEach(function (prop) {
    outObjProps[prop.FieldName] = prop.FieldValue;
  });
  return outObjProps;
};

var playbookControl = {
  pbLogon: function (auth, callback) {
    // pbLogon accepts auth and callback
    // xhr request creates session on the playbook server
    // updates xtoken in the global auth variable
    // invokes callback with logon response
    var logonReq = new XMLHttpRequest();
    // logonReq.withCredentials = true;

    logonReq.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 201) {
        var response = JSON.parse(this.responseText);
        //console.log("logged in successfully at " + new Date().toUTCString());
        auth.xToken = response.SessionID;
        if (typeof callback === "function") {
          callback(response);
        }
      } else if (
        this.readyState == 4 &&
        (this.status === 404 || this.status === 403 || this.status === 401)
      ) {
        if (typeof callback === "function") {
          callback(`${this.status}`);
        }
      } else if (this.readyState == 4 && this.status > 201) {
        if (typeof callback === "function") {
          callback(null);
        }
      } else if (this.readyState == 4) {
        callback(null);
      }
    };
    // logonReq.addEventListener("load", reqListener);
    logonReq.open("POST", auth.playbookUri + "/logon", true);
    logonReq.setRequestHeader("Content-Type", "application/json;charset=utf-8");
    logonReq.send(
      JSON.stringify({
        staffUserId: auth.userId,
        domainUserId: auth.userId,
        password: auth.password,
        domainName: auth.domain,
        devKey: auth.devKey,
        // iClientType: 14,
        iClientType: 7,
      })
    );
  },
  pbLogout: function (auth, callback) {
    var logoutReq = new XMLHttpRequest();
    // logoutReq.withCredentials = true;
    logoutReq.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        auth.xToken = "";
        if (typeof callback === "function") {
          callback(true);
        }
        //console.log("logout successful");
      } else if (this.readyState == 4 && this.status != 200) {
        if (typeof callback === "function") {
          callback(false);
        }
        //console.log("logout failed");
      }
    };
    logoutReq.open("GET", auth.playbookUri + "/Logout");
    logoutReq.setRequestHeader(
      "Content-Type",
      "application/json;charset=utf-8"
    );
    logoutReq.setRequestHeader("X-ENPS-TOKEN", auth.xToken);
    logoutReq.send();
  },
  pbPing: function (auth, callback) {
    var pingReq = new XMLHttpRequest();
    // pingReq.withCredentials = true;
    pingReq.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        if (typeof callback === "function") {
          callback(this.responseText);
        }
        //console.log("ping successful");
      } else if (
        this.readyState == 4 &&
        (this.status === 401 || this.status === 404)
      ) {
        if (typeof callback === "function") {
          callback(`${this.status}`);
        }
        //console.log("ping failed");
      } else if (this.readyState == 4 && this.status != 200) {
        if (typeof callback === "function") {
          callback(false);
        }
        //console.log("ping failed");
      }
    };
    pingReq.open("GET", auth.playbookUri + "/Ping");
    pingReq.setRequestHeader("Content-Type", "application/json;charset=utf-8");
    pingReq.setRequestHeader("X-ENPS-TOKEN", auth.xToken);
    pingReq.send();
  },
  pbGtables: function (auth, callback) {
    var tableReq = new XMLHttpRequest();
    // tableReq.withCredentials = true;
    tableReq.addEventListener("load", function () {
      if (this.readyState == 4 && this.status == 200) {
        var gTables = JSON.parse(this.responseText);
        gTables._LanguageSettings = convertObjectProperties(
          gTables._LanguageSettings
        );
        gTables._ConfigSettings = convertObjectProperties(
          gTables._ConfigSettings
        );
        if (typeof callback === "function") {
          callback(gTables);
        }
      } else if (this.readyState == 4 && this.status != 200) {
        if (typeof callback === "function") {
          callback(false);
        }
        return;
      }
    });
    tableReq.open(
      "GET",
      auth.playbookUri +
        "/GlobalTables?filterLangPrefix=PSTWeb&filterInActiveUsers=True",
      true
    );
    tableReq.setRequestHeader("Content-Type", "application/json;charset=utf-8");
    tableReq.setRequestHeader("X-ENPS-TOKEN", auth.xToken);
    tableReq.send();
  },
  pbGfields: function (auth, callback) {
    var playbookFields = {
      complete: {},
      topics: {},
      assignments: {},
    };
    var fieldReq = new XMLHttpRequest();
    // fieldReq.withCredentials = true;
    fieldReq.addEventListener("load", function () {
      if (this.readyState == 4 && this.status == 200) {
        var gFields = JSON.parse(this.responseText);

        playbookFields.complete = gFields;
        if (typeof callback === "function") {
          callback(playbookFields);
        }
      } else if (this.readyState == 4 && this.status != 200) {
        if (typeof callback === "function") {
          callback(false);
        }
        return;
      }
    });

    fieldReq.open(
      "GET",
      auth.playbookUri +
        "/GlobalFields?filterLangPrefix=PSTWeb&filterInActiveUsers=True",
      true
    );
    fieldReq.setRequestHeader("Content-Type", "application/json;charset=utf-8");
    fieldReq.setRequestHeader("X-ENPS-TOKEN", auth.xToken);
    fieldReq.send();
  },
  pbSearchFields: function (auth, searchOptions, callback) {
    var searchFieldsPayload = {
      Database: searchOptions.database,
      QueryTerms: searchOptions.queryTerms,
      zFields: searchOptions.zFields,
      NOMLocations: searchOptions.NOMLocations,
      NOMContentTypes: searchOptions.NOMContentTypes,
      NOMContentDates: searchOptions.NOMContentDates,
      WireSearchParameters: {
        SearchWires: false,
        Categories: [],
        Providers: [],
        DateOptions: {
          All: true,
          CustomDateRange: false,
          FortyEightHours: false,
          Future: false,
          ItemDateFrom: "1800-02-28T22:00:00.000Z",
          ItemDateTo: "1800-02-28T22:00:00.000Z",
          OneHour: false,
          OneWeek: false,
          TwentyFourHours: false,
          TwoHours: false,
        },
        ExtendedWireBriefing: true,
      },
      MaxRows: searchOptions.maxRecords,
      SortByRank: false,
      SortFields: [
        {
          FieldName: "modTime",
          FieldValue: "desc",
        },
        {
          FieldName: "guid",
          FieldValue: "asc",
        },
      ],
      ExactMatch: false,
      FieldsToReturn: searchOptions.fieldsToReturn,
    };
    // console.log(searchFieldsPayload);

    var searchFieldsReq = new XMLHttpRequest();
    searchFieldsReq.addEventListener("load", function () {
      if (this.readyState == 4 && this.status == 206) {
        var response = JSON.parse(this.responseText);
        if (response.SearchResults != null) {
          if (typeof callback === "function") {
            callback(response);
          }
        } else {
          callback();
        }
      } else if (
        (this.readyState == 4 && this.status === 401) ||
        (this.readyState == 4 &&
          this.status === 500 &&
          this.responseText.toLowerCase().indexOf("session") > -1)
      ) {
        if (typeof callback === "function") {
          callback("401");
        }
      } else if (this.readyState == 4 && this.status != 206) {
        if (typeof callback === "function") {
          callback();
        }
      }
    });
    searchFieldsReq.open("POST", auth.playbookUri + "/SearchFields", true);
    searchFieldsReq.setRequestHeader(
      "Content-Type",
      "application/json;charset=utf-8"
    );
    searchFieldsReq.setRequestHeader("X-ENPS-TOKEN", auth.xToken);
    searchFieldsReq.send(JSON.stringify(searchFieldsPayload));
  },
  getEnpsRundown: function (auth, database, path, guid, callback) {
    var data = null;
    var xhr = new XMLHttpRequest();
    // xhr.withCredentials = true;
    xhr.addEventListener("load", function () {
      if (this.readyState == 4 && this.status == 200) {
        var response = JSON.parse(this.responseText);
        if (response != null) {
          if (typeof callback === "function") {
            callback(response);
          }
        } else {
          callback();
        }
      } else if (this.readyState == 4 && this.status === 401) {
        //console.log("search error");
        if (typeof callback === "function") {
          callback("401");
        }
      } else if (this.readyState == 4 && this.status != 200) {
        //console.log("search error");
        if (typeof callback === "function") {
          callback(null);
        }
      }
    });

    xhr.open(
      "GET",
      auth.playbookUri +
        "/RundownContent?database=" +
        database +
        "&path=" +
        path +
        "&guid=" +
        guid +
        "&hitHighlightTerm=&returnText=false"
    );
    xhr.setRequestHeader("X-ENPS-TOKEN", auth.xToken);
    xhr.setRequestHeader("Content-Type", "application/json; charset=utf-8");

    xhr.send(data);
  },
  patchBasicContent: function (auth, options, callback) {
    const zFields = Object.keys(options.zFields).map((x) => {
      return {
        FieldValue: options.zFields[x],
        FieldName: x.charAt(0).toUpperCase() + x.slice(1),
      };
    });
    let data = {
      database: options.database,
      path: options.path,
      guid: options.guid,
      keepApproved: true,
      fieldsToUpdate: zFields,
      type: options.zFields.type,
    };
    var xhr = new XMLHttpRequest();
    // xhr.withCredentials = true;
    xhr.addEventListener("readystatechange", function () {
      if (this.readyState == 4 && this.status == 200) {
        var response = JSON.parse(this.responseText);
        if (response != null) {
          // console.log(response);
          if (typeof callback === "function") {
            callback(response);
          }
        } else {
          callback();
        }
      } else if (this.readyState == 4 && this.status != 200) {
        //console.log("search error");
        if (typeof callback === "function") {
          callback();
        }
      }
    });

    xhr.open("PATCH", auth.playbookUri + "/BasicContent");
    xhr.setRequestHeader("X-ENPS-TOKEN", auth.xToken);
    xhr.setRequestHeader("Content-Type", "application/json; charset=utf-8");

    xhr.send(JSON.stringify(data));
  },
  putEnpsRundown: function (auth, options, callback) {
    //check/set required values
    let d = new Date().toISOString().split("T")[0];
    options.path = `${options.path}`
      .toUpperCase()
      .match(/[UP]_[A-Z0-9.-]+\\+[A-Z0-9\\]+?/g)
      ? options.path
      : "U_" + auth.userId + "\\W";
    options.zFields = options.zFields || {};
    options.zFields.StartTime =
      options.zFields.StartTime || d + "T08:00:00.000Z";
    options.zFields.EndTime = options.zFields.EndTime
      ? options.zFields.EndTime
      : d + "T09:00:00.000Z";
    options.zFields.Type = 2;
    options.zFields.Title = options.zFields.Title
      ? options.zFields.Title
      : "new rundown";

    const zFields = Object.keys(options.zFields).map((x) => {
      return {
        FieldValue: options.zFields[x],
        FieldName: x.charAt(0).toUpperCase() + x.slice(1),
      };
    });
    var data = {
      database: options.database,
      fieldsToUpdate: zFields,
      keepApproved: false,
      path: options.path,
      templateGuid: options.templateGuid ? options.templateGuid : "",
      templateProgramId: options.templateGuid ? options.templateGuid : "",
    };

    var xhr = new XMLHttpRequest();
    // xhr.withCredentials = true;
    xhr.addEventListener("readystatechange", function () {
      if (this.readyState == 4 && this.status == 200) {
        var response = JSON.parse(this.responseText);
        if (response != null) {
          if (typeof callback === "function") {
            callback(response);
          }
        } else {
          callback();
        }
      } else if (this.readyState == 4 && this.status != 200) {
        //console.log("search error");
        if (typeof callback === "function") {
          callback();
        }
      }
    });

    xhr.open("PUT", auth.playbookUri + "/RundownContent");
    xhr.setRequestHeader("X-ENPS-TOKEN", auth.xToken);
    xhr.setRequestHeader("Content-Type", "application/json; charset=utf-8");

    xhr.send(JSON.stringify(data));
  },
  pbListContent: function (auth, options, callback) {
    var data = {
      Database: options.database,
      ENPSListParameters: [
        {
          Path: options.path || "U_" + auth.userId + "\\W",
          Guid: "",
          Type: options.type || 2,
          StartTime: options.StartTime || "1800-03-01T05:00:00.000Z",
          EndTime: options.EndTime || "1800-03-01T05:00:00.000Z",
          Priority: null,
          UnreadBy: "",
        },
      ],
    };
    var xhr = new XMLHttpRequest();
    // xhr.withCredentials = true;

    xhr.addEventListener("readystatechange", function () {
      if (this.readyState == 4 && this.status == 206) {
        var response = JSON.parse(this.responseText);
        if (response != null) {
          // console.log(response);
          if (typeof callback === "function") {
            callback(response);
          }
        } else {
          callback();
        }
      } else if (this.readyState == 4 && this.status === 401) {
        //console.log("search error");
        if (typeof callback === "function") {
          callback("401");
        }
      } else if (this.readyState == 4 && this.status != 206) {
        //console.log("search error");
        if (typeof callback === "function") {
          callback(null);
        }
      }
    });

    xhr.open("POST", auth.playbookUri + "/Lists");
    xhr.setRequestHeader("X-ENPS-TOKEN", auth.xToken);
    xhr.setRequestHeader("Content-Type", "application/json; charset=utf-8");

    xhr.send(JSON.stringify(data));
  },
  pbGetSSOSettings: function (auth, callback) {
    var SSOReq = new XMLHttpRequest();
    // pingReq.withCredentials = true;
    SSOReq.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        var ssoSettingsArr = JSON.parse(this.responseText);
        if (typeof callback === "function") {
          callback(ssoSettingsArr);
        }
      } else if (this.readyState == 4 && this.status != 200) {
        if (typeof callback === "function") {
          callback(false);
        }
      }
    };
    SSOReq.open("GET", auth.playbookUri + "/SSOSettings");
    SSOReq.setRequestHeader("Content-Type", "application/json;charset=utf-8");
    SSOReq.send();
  },
  pbGetSSOConfigSettings: function (auth, callback) {
    var SSOReq = new XMLHttpRequest();
    // pingReq.withCredentials = true;
    SSOReq.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        var ssoConfigSettingsObj = JSON.parse(this.responseText);
        if (typeof callback === "function") {
          callback(ssoConfigSettingsObj);
        }
      } else if (this.readyState == 4 && this.status != 200) {
        if (typeof callback === "function") {
          callback(false);
        }
      }
    };
    SSOReq.open("GET", auth.playbookUri + "/SSOConfigSetings");
    SSOReq.setRequestHeader("Content-Type", "application/json;charset=utf-8");
    SSOReq.send();
  },
  pbSSOLogon: function (auth, callback) {
    // pbLogon accepts auth and callback
    // xhr request creates session on the playbook server
    // updates xtoken in the global auth variable
    // invokes callback with logon response
    var logonSSOReq = new XMLHttpRequest();
    // logonReq.withCredentials = true;

    logonSSOReq.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 201) {
        var response = JSON.parse(this.responseText);
        //console.log("logged in successfully at " + new Date().toUTCString());
        auth.xToken = response.SessionID;
        if (typeof callback === "function") {
          callback(response);
        }
      } else if (
        this.readyState == 4 &&
        (this.status === 404 || this.status === 403 || this.status === 401)
      ) {
        if (typeof callback === "function") {
          callback(`${this.status}`);
        }
      } else if (this.readyState == 4 && this.status > 201) {
        if (typeof callback === "function") {
          callback(null);
        }
      } else if (this.readyState == 4) {
        callback(null);
      }
    };
    // logonReq.addEventListener("load", reqListener);
    logonSSOReq.open("POST", auth.playbookUri + "/LogonSSO", true);
    logonSSOReq.setRequestHeader(
      "Content-Type",
      "application/json;charset=utf-8"
    );
    logonSSOReq.send(
      JSON.stringify({
        ssoProvider: localStorage.getItem("ssoProvider"),
        ssoToken: auth.ssoToken[1],
        // staffUserId: auth.userId,
        // domainUserId: auth.userId,
        // password: auth.password,
        domainName: auth.domain,
        devKey: auth.devKey,
        // iClientType: 14,
        iClientType: 7,
      })
    );
  },
  scrapePlaybookServiceAddresses: function (auth, callback) {
    let scraper = new XMLHttpRequest();
    let playbookURL = new URL(auth.playbookUri);
    let playbookHost = playbookURL.host || playbookURL.hostname;
    scraper.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        let serverConfig = JSON.parse(this.responseText);
        callback(serverConfig);
      } else if (this.readyState == 4 && this.status != 200) {
        callback(false);
      }
    };
    scraper.open(
      "GET",
      "https://yomrqy9rwj.execute-api.us-east-2.amazonaws.com/default/playbook-url-scraper?x-playbook-host=" +
        playbookHost
    );
    scraper.setRequestHeader("Content-Type", "application/json;charset=utf-8");
    scraper.send();
  },
};

var clearHTMLTags = function (str) {
  var div = document.createElement("div");
  div.innerHTML = str;
  var text = div.textContent || div.innerText || "";
  return text;
};
module.exports = {
  clearHTMLTags,
  convertObjectProperties,
  isRequired,
  playbookControl,
};
